import { useState } from 'react';
import classNames from 'classnames';

import './shoppingCartItem.scss';
import ShoppingCartItemRateDetails from './ShoppingCartItemRateDetails';
import { InfoIcon, CollapseIcon } from '../Icons';
import { formatPrice } from '@micro-apps/shared';
import { useTranslation, useBreakpoint } from '../../../hooks';
import Image from '../../Image';

export default function ShoppingCartItem({
	currencyCode,
	name,
	cartDescription,
	roomRate,
	numberOfPeople,
	duration,
	price,
	stayResortFees,
	taxAndFees = 'Taxes & fees may apply',
	quantity,
	removeItem,
	showInfoModal,
	insideCart = false,
	productType,
	image = '',
	onRequestEventProductType = '',
	unitType,
	complimentaryPricingInfo,
	requestDate,
	isMpeJourney = false,
}) {
	const { t } = useTranslation();
	const breakpoint = useBreakpoint();
	const isMobile = !breakpoint.includes('large');

	const [showRoomRateDetails, setShowRoomRateDetails] = useState(true);

	return (
		<div>
			<div className="shopping-cart-item">
				{insideCart && image ? (
					<div className="shopping-cart-item__col shopping-cart-item__col__image">
						<Image className="shopping-cart-item__image" src={image} alt={name} />
					</div>
				) : undefined}

				<div className="shopping-cart-item__col shopping-cart-item__col__info">
					{insideCart && onRequestEventProductType ? (
						<div className="ty-h4 summary-itinerary__items__type">{onRequestEventProductType}</div>
					) : undefined}

					<span className="ty-c3 shopping-cart-item__col__item-name">{name}</span>

					{cartDescription && (!insideCart || !isMobile) && (
						<span className="ty-c4 shopping-cart-item__col__item-description">
							{cartDescription}
						</span>
					)}

					{(numberOfPeople || duration) && (
						<span className="ty-c4 shopping-cart-item__col__item-numberPeople">
							{[
								insideCart && isMobile && cartDescription ? cartDescription : undefined,
								duration,
								numberOfPeople,
							]
								.filter(Boolean)
								.join(' / ')}
						</span>
					)}

					{quantity > 0 && (
						<span className="ty-c4 shopping-cart-item__col__item-description">
							{t('Quantity')}: {quantity}
						</span>
					)}

					{requestDate && (
						<span className="ty-c4 shopping-cart-item__col__item-description">{requestDate}</span>
					)}

					{removeItem && (
						<button
							type="button"
							onClick={removeItem}
							className="ty-c4 shopping-cart-item__col__remove CTA CTA--underlined--light"
						>
							{t('Remove')}
						</button>
					)}
				</div>
				<div className="shopping-cart-item__col">
					<span className="shopping-cart-item__col__price shopping-cart-item__col__price">
						{complimentaryPricingInfo ? (
							<span className={isMobile ? 'ty-c4' : 'ty-c3'}> {complimentaryPricingInfo}</span>
						) : (
							<>
								{showInfoModal && unitType !== 'Price per unit' && (
									<button
										title={t('Information')}
										type="button"
										onClick={showInfoModal}
										className="shopping-cart-item__col__price__info-icon-btn shopping-cart-item__col__price__info-icon"
										data-cy="show-info-modal-btn"
									>
										<InfoIcon />
									</button>
								)}
								{formatPrice({
									value: price,
									currencyCode,
								})}
							</>
						)}
					</span>
					<span
						className={classNames('shopping-cart-item__col__price-terms', {
							'shopping-cart-item__col__price-terms--hotel': productType === 'HOTEL',
						})}
						data-cy="shopping-cart-item__taxes-and-fees"
					>
						{t(taxAndFees)}
					</span>
				</div>
			</div>
			{!insideCart && roomRate && !isMpeJourney && (
				<>
					<button
						type="button"
						onClick={() => {
							setShowRoomRateDetails(prev => !prev);
						}}
						className={classNames('toggle-rate toggle-rate__collapse-icon', {
							'toggle-rate__collapse-icon--flipped': !showRoomRateDetails,
						})}
					>
						<div className="ty-c4">
							{showRoomRateDetails ? t('Hide Rate Details') : t('View Rate Details')}
						</div>
						<CollapseIcon />
					</button>
					{showRoomRateDetails && (
						<ShoppingCartItemRateDetails
							roomRate={roomRate}
							currencyCode={currencyCode}
							stayResortFees={stayResortFees}
							taxAndFees={taxAndFees}
						/>
					)}
				</>
			)}
		</div>
	);
}
